import dayjs from 'dayjs'
import { randomId } from '@mui/x-data-grid-generator'
import { roundTo } from 'utils/data-manipulation/valueFormatter'
import { ROUNDING_PRECISIONS } from 'utils/constants'

export const formatData = data => ({
  fromMaterial: {
    materialTypeId: data?.from?.material?.id,
    weight: roundTo(Number(data?.from?.quantity || 0), ROUNDING_PRECISIONS.WEIGHT),
  },
  toMaterials: data?.to?.map(toMaterial => ({
    materialTypeId: toMaterial?.material?.id,
    weight: roundTo(Number(toMaterial?.quantity || 0), ROUNDING_PRECISIONS.WEIGHT),
  })),
  notes: data?.notes,
  effectiveDate: dayjs(data?.effectiveDate).toISOString(),
})

// DELETE FROM THIS WHEN DEPRECATE FF enableDisplayRegradeInformation
export const formatDataLegacy = (data, toMaterials) => ({
  fromMaterial: {
    materialTypeId: data.from?.material?.materialTypeId,
    weight: roundTo(Number(data.from?.quantity || 0), ROUNDING_PRECISIONS.WEIGHT),
  },
  toMaterials: toMaterials.map(material => ({
    materialTypeId: data[material.id]?.material?.materialTypeId,
    weight: roundTo(Number(data[material.id]?.quantity || 0), ROUNDING_PRECISIONS.WEIGHT),
  })),
  notes: data?.notes,
  effectiveDate: dayjs(data?.effectiveDate).toISOString(),
})

export const getToValues = (data, toMaterials) =>
  toMaterials.map(material => ({
    materialTypeId: data[material.id]?.material?.materialTypeId,
    weight: data[material.id]?.quantity,
  }))
// DELETE UNTIL HERE WHEN DEPRECATE FF enableDisplayRegradeInformation

export const getNewMaterial = () => {
  const rowId = randomId()

  return {
    id: rowId,
    name: rowId,
    quantity: '',
  }
}
